import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { getLibroMasPrestado, getNumeroPrestamosActivos, getNumeroTotalPrestamosEntreFechas, getNumeroTotalLibrosEnInventario, getNumeroTotalUsuariosRegistrados } from "../../../services/EstadisticasService";
import { format } from "date-fns";
import "./index.css";
import { acortarTexto } from "../../../utils/functions";

export default function BasicTable() {
  const [libroMasPrestado, setLibroMasPrestado] = useState(null);
  const [numeroPrestamosActivos, setNumeroPrestamosActivos] = useState(0);
  const [numeroTotalPrestamos, setNumeroTotalPrestamos] = useState(0);
  const [numeroTotalLibrosEnInventario, setNumeroTotalLibrosEnInventario] = useState(0);
  const [numeroTotalUsuariosRegistrados, setNumeroTotalUsuariosRegistrados] = useState(0);


  const [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate() - 7))); // Por defecto, hace 7 días
  const [endDate, setEndDate] = useState(new Date()); // Fecha actual

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formattedStartDate = format(startDate, "yyyy-MM-dd");
        const formattedEndDate = format(endDate, "yyyy-MM-dd");

        const libro = await getLibroMasPrestado(formattedStartDate, formattedEndDate);
        setLibroMasPrestado(libro);

        const prestamosActivos = await getNumeroPrestamosActivos();
        setNumeroPrestamosActivos(prestamosActivos);

        const totalPrestamos = await getNumeroTotalPrestamosEntreFechas(formattedStartDate, formattedEndDate);
        setNumeroTotalPrestamos(totalPrestamos);

        const totalLibros = await getNumeroTotalLibrosEnInventario();
        setNumeroTotalLibrosEnInventario(totalLibros);

        const totalUsuarios = await getNumeroTotalUsuariosRegistrados();
        setNumeroTotalUsuariosRegistrados(totalUsuarios);
      } catch (error) {
        console.error("Error al obtener estadísticas:", error);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  return (
    <div className="Table">
      <h3>Datos Clave</h3>
      <div className="date-selectors">
        <label>Fecha Inicio:</label>
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          dateFormat="dd/MM/yyyy"
          maxDate={endDate}
        />
        <label>Fecha Fin:</label>
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          dateFormat="dd/MM/yyyy"
          minDate={startDate}
          maxDate={new Date()}
        />
      </div>
      <TableContainer
        component={Paper}
        style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ fontSize: '17px', color: '#0B545B'}}>Estadística</TableCell>
              <TableCell align="center" style={{ fontSize: '17px' , color: '#0B545B'}}>Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key="libroMasPrestado">
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Nombre del libro más prestado</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold', color: '#788097'}} >
                {libroMasPrestado ? (
                  <>
                    {acortarTexto(libroMasPrestado.nombre, 50)} ({libroMasPrestado.cantidad} préstamos)
                  </>
                ) : (
                  "No hay datos en este rango de fechas."
                )}
              </TableCell>
            </TableRow>
            <TableRow key="numeroTotalPrestamos">
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Número total de préstamos hechos</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold', color: '#788097'}}>{numeroTotalPrestamos}</TableCell>
            </TableRow>
            <TableRow key="numeroPrestamosActivos">
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Número de préstamos activos</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold', color: '#788097'}}>{numeroPrestamosActivos}</TableCell>
            </TableRow>
            <TableRow key="numeroTotalLibrosEnInventario">
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Número total de libros en inventario</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold', color: '#788097'}}>{numeroTotalLibrosEnInventario}</TableCell>
            </TableRow>
            <TableRow key="numeroTotalUsuariosRegistrados">
              <TableCell align="center" style={{ fontWeight: 'bold' }}>Número total de usuarios registrados</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold', color: '#788097'}}>{numeroTotalUsuariosRegistrados}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
